import ProgressModule from './module';

export default ProgressModule;
